import React from "react";


const NavData = [{
        'name': "داشبورد",
        'isSubmenu': false,
        'link': '/p/dashboard',
        "viewBox": "0 0 32 32",
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'name': "گزارش ها",
        'isSubmenu': true,
        "viewBox": "0 0 460 460",
        "icon": "/assetes/svg/report.svg#report",
        "submenu": [{
                'name': "تردد",
                'link': '/p/reports/rollcall',
            },
            {
                'name': "تاخیر",
                'link': '/p/reports/delay',
            },
            {
                'name': "اضافه کاری",
                'link': '/p/reports/overtime',
            },
            {
                'name': "مرخصی",
                'link': '/p/reports/vacation',
            },
            {
                'name': "غیبت",
                'link': '/p/reports/absence',
            },
        ]
    },
    {
        'name': "پرسنل",
        'isSubmenu': false,
        'link': '/p/users',
        "viewBox": "0 0 512 512",
        "icon": "/assetes/svg/person.svg#person"
    },
    {
        'name': "تنظیمات",
        'isSubmenu': true,
        "viewBox": "0 0 512 512",
        "icon": "/assetes/svg/cog.svg#cog",
        "submenu": [{
                'name': "گروه مشاغل",
                'link': '/p/settings/job-groups',
            },
            {
                'name': "مشاغل",
                'link': '/p/settings/job',
            },
            {
                'name': "روزهای تعطیل",
                'link': '/p/settings/holidays',
            },
            {
                'name': "شیفت کاری",
                'link': '/p/settings/schedules',
            },
            {
                'name': "علل تاخیر",
                'link': '/p/settings/delay-reasons',
            },
            {
                'name': "علل مرخصی",
                'link': '/p/settings/vacation-reasons',
            },
            {
                'name': "عملیات ها",
                'link': '/p/settings/operations',
            },
        ]
    },
    {
        'name': "اطلاعات شرکت",
        'isSubmenu': false,
        'link': '/p/company',
        "viewBox": "0 0 279 279",
        "icon": "/assetes/svg/bag.svg#bag"
    },
    {
        'name': "موقعیت مکانی",
        'isSubmenu': false,
        'link': '/p/location',
        "viewBox": "0 0 20 20",
        "icon": "/assetes/svg/location.svg#location"
    },
    {
        'name': "تاریخچه خرید",
        'isSubmenu': false,
        'link': '/p/purchase-history',
        "viewBox": "0 0 57 57",
        "icon": "/assetes/svg/history.svg#history"
    },

]

export default NavData;